import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './parceiroForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaCidade } from './parceiroActions';
import { getLista as getListaTipoProducao } from '../tipoProducao/tipoProducaoActions';

const columns = [
  {
    field: 'razao_social',
    type: 'text'
  }, {
    field: 'cpf_cnpj',
    type: 'cpf',
    formatter: row => row.cpf || row.cnpj
  }, {
    field: 'nome_cidade',
    type: 'text'
  }, {
    field: 'nome_tipo_producao',
    type: 'text'
  }
];

class Parceiro extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'razao_social',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaCidade();
		this.props.getListaTipoProducao();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.razao_social}
					${item.cpf || item.cnpj}
					${item.nome_cidade}
					${item.nome_tipo_producao}
				`.toUpperCase().includes(pesquisar)
				);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ tipo_pessoa: 'juridica' });
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Parceiroes'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='razao_social'
									label='Nome / Razão Social'
									width={300}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='cpf_cnpj'
									label='CPF / CNPJ'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_cidade'
									label='Cidade'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_tipo_producao'
									label='Tipo de Produção'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.razao_social}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.cpf || item.cnpj}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_cidade}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_tipo_producao}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={true}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item
			}))} name='Parceiroes'>
				{[
					{ componente: <ExcelColumn key={1} label='Código da Integração' value='codigo_integracao'/>},
					{ componente: <ExcelColumn key={2} label='Nome / Razão Social' value='razao_social'/>},
					{ componente: <ExcelColumn key={3} label='Nome Fantasia' value='nome_fantasia'/>},
					{ componente: <ExcelColumn key={4} label='CNPJ' value='cnpj'/>},
					{ componente: <ExcelColumn key={5} label='CPF' value='cpf'/>},
					{ componente: <ExcelColumn key={6} label='RG' value='rg'/>},
					{ componente: <ExcelColumn key={7} label='IE' value='ie'/>},
					{ componente: <ExcelColumn key={8} label='Endereço' value='endereco'/>},
					{ componente: <ExcelColumn key={9} label='Número' value='numero'/>},
					{ componente: <ExcelColumn key={10} label='Complemento' value='complemento'/>},
					{ componente: <ExcelColumn key={11} label='Bairro' value='bairro'/>},
					{ componente: <ExcelColumn key={12} label='CEP' value='cep'/>},
					{ componente: <ExcelColumn key={13} label='Cidade' value='nome_cidade'/>},
					{ componente: <ExcelColumn key={14} label='Telegram' value='telegram'/>},
					{ componente: <ExcelColumn key={15} label='WhatsApp' value='whatsapp'/>},
					{ componente: <ExcelColumn key={16} label='E-mail' value='email'/>},
					{ componente: <ExcelColumn key={17} label='Latitude' value='latitude'/>},
					{ componente: <ExcelColumn key={18} label='Longitude' value='longitude'/>},
					{ componente: <ExcelColumn key={19} label='Tipo de Produção' value='nome_tipo_producao'/>},
					{ componente: <ExcelColumn key={20} label='Solicitar Silo' value='solicita_silo'/>},
					{ componente: <ExcelColumn key={21} label='Solicitar Lote' value='solicita_lote'/>},
					{ componente: <ExcelColumn key={22} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={23} label='Usuário da Alteração' value='nome_usuario_alteracao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.parceiro.modoTela,
	aguardando: state.parceiro.aguardando,
	lista: state.parceiro.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaCidade, getListaTipoProducao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Parceiro);